export default function formatLimitString(value: string | undefined, limit: number): string {
  if (!value || !limit) return '';
  return value.length > limit ? value.slice(0, limit).concat('...') : value;
}
